// ** Next Imports

// ** React Imports
import { useState } from "react";
import { Alert, Form, Spinner, InputGroup } from "react-bootstrap";

// ** File Imports
import Layout, { SEOHead } from "../../layouts/default";
import { roundTo, API } from "../../helpers";
import { FaqSidebar } from "../../components/support/faqPages";
import { DEFAULT_ERROR } from "../../helpers/DATA";

interface ApiResponse {
  url: URL;
}

const QuickPay = () => {
  const [amount, setAmount] = useState<string>("");
  const [errors, setErrors] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getPaymentLink = () => {
    setErrors(null);

    //Check Amount
    const linkAmount = roundTo(parseFloat(amount), 2);
    if (!linkAmount || isNaN(linkAmount) || linkAmount <= 0)
      return setErrors("Please enter a valid amount more than 0");

    //Send to API
    setLoading(true);
    API("quick-pay-link", { amount: linkAmount }, "POST")
      .then(async (res: ApiResponse) => {
        if (res?.url) window.location.replace(res.url);
        else setErrors(DEFAULT_ERROR);
      })
      .catch((e: Error) => {
        console.error("QP ERROR", e);
        setErrors(DEFAULT_ERROR);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Layout>
      <SEOHead title=" Easy Internet Now | Quick Pay | EIN Payment Method">
        <meta
          name="description"
          content="EIN is the internet service provider that allows you to make quick payment method from the customer portal on the website.Check availability by address"
        ></meta>
        <meta name="keywords" content="Easy Internet Now" />
      </SEOHead>
      <section className="bg-silver1 pad-top-40 pad-bot-40">
        <div className="container">
          <div className="sec-head">
            <h1 className="no-margin">
              <b>Quick Pay</b>
            </h1>
          </div>
        </div>
      </section>

      <section className="pad-top-60 pad-bot-60">
        <div className="container">
          <Alert
            variant="danger"
            className="animate__animated animate__wobble"
            show={errors ? true : false}
          >
            {errors}
          </Alert>

          <div className="row">
            <div className="col-md-9 col-lg-9 col-sm-9 col-12">
              <h4 className="col-black">Enter an amount to pay</h4>

              <InputGroup className="mb-3">
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                  className="field-style1"
                  type="number"
                  step="0.01"
                  min="0.01"
                  placeholder="Total"
                  style={{
                    maxWidth: "200px",
                  }}
                  disabled={loading}
                  value={amount}
                  onChange={(e) => {
                    setAmount(e.target.value);
                  }}
                />
              </InputGroup>
              <hr />
              <button
                type="button"
                className="submit-btn1"
                onClick={() => {
                  getPaymentLink();
                }}
                disabled={loading}
              >
                {loading ? (
                  <span>
                    Going to secure payment
                    <Spinner animation="border" variant="default" />
                  </span>
                ) : (
                  "Secure Pay"
                )}
              </button>
            </div>
            <FaqSidebar />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default QuickPay;
